import * as actionTypes from "../actions/actionTypes";
import {updateObject} from "../utility";
 
const initialState ={
//For Coupon
    couponAddBtnLoading:false,
    couponRemoveBtnLoading:false,
    displayRemove:"none",
    displayApply:"block",
    disabled:false,
    response:"",
    responseDisplay:"",
//\\
    order: { 
        finalPrice: 0,
        productsPrice:0,
        totalQuantity:0,
        // priceWithoutDiscout:0,
        userId: "",
        phoneNumber: null,
        userName: "",
        address: {},
        products: [], 
        payment_mode: "",
        delivery:0,
        // bookingDate: null,
        // orderDate: null,
        // orderType: "",
        // orderDay: "",
        
      },
    
      loading:false,
      cartProductsLoading:false,
      cartProducts:null,
      outOfStockProducts:[],
      orderSummary:{},
      placeOrderBtnLoading:false
}
 
const reducer = (state = initialState,action)=>{
    switch(action.type){
        case actionTypes.CART_PRODUCT_CONTROLS:
            return updateObject(state, action.payload);
        case actionTypes.SET_CART_ORDER:
            return updateObject(state,{order:{...state.order,...action.payload}})
        case actionTypes.SET_COUPON:
            return updateObject(state,{order:{...state.order,...action.payload}}) 
    default:
        return state;
    }
}

export default reducer;